var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3053 5.10485L19.808 10.9452C20.0248 11.1139 20.0638 11.4267 19.8952 11.6437C19.801 11.7649 19.6561 11.8358 19.5026 11.8358H17.9681V19.3022C17.9681 19.5771 17.7454 19.8 17.4708 19.8H14.4867C14.212 19.8 13.9894 19.5771 13.9894 19.3022V15.8179C13.9894 14.7183 13.0987 13.8269 12 13.8269C10.9013 13.8269 10.0106 14.7183 10.0106 15.8179V19.3022C10.0106 19.5771 9.78795 19.8 9.51327 19.8H6.52922C6.25454 19.8 6.03188 19.5771 6.03188 19.3022V11.8358H4.49734C4.22267 11.8358 4 11.613 4 11.3381C4 11.1845 4.07086 11.0395 4.192 10.9452L11.6946 5.10485C11.8742 4.96505 12.1257 4.96505 12.3053 5.10485ZM5.94687 10.8403H7.02656V18.8045H9.01593V15.8179C9.01593 14.1685 10.3519 12.8313 12 12.8313C13.648 12.8313 14.984 14.1685 14.984 15.8179V18.8045H16.9734V10.8403H18.0531L12 6.12836L5.94687 10.8403Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.7381c3f2a770245038409d2dbae144ac.svg";
export { ForwardRef as ReactComponent };